import { getUserPositionId } from "../js/storage";
const position_id = getUserPositionId();

export default {
  name: "阵地活动",
  listTitle: "阵地活动列表",
  url: "/position-activity", // rest接口表名
  query: "&sort=sort,-id&expand=admin,position", // rest接口query参数
  // 列表渲染列
  columns: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { title: "发布时间", dataIndex: "create_time" },
      { title: "活动名称", dataIndex: "name" },
      {
        title: "阵地名称",
        dataIndex: "positionName",
        customRender: (text, record) => {
          return <span>{record.position?.name}</span>;
        },
      },
      { title: "排序", dataIndex: "sort" },
    ];
  },
  defaultQuery: { position_id },
  // 列表查询表单
  queryForm: [
    {
      key: "position_id",
      label: "",
      component: "a-select",
      entity: "position",
      props: {
        options: [],
        allowClear: true,
        placeholder: "请选择阵地搜索",
        disabled: !!position_id,
      },
      style: { width: "240px" },
    },
    {
      key: "name",
      label: "",
      component: "a-input",
      props: {
        placeholder: "请输入活动名称搜索",
        allowClear: true,
      },
      style: { width: "240px" },
    },
  ],
  // 新增/编辑查询表单
  items: [
    {
      key: "name",
      label: "活动名称",
      component: "a-input",
      props: {
        placeholder: "请输入活动名称",
      },
      rules: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
    },
    {
      key: "start_time",
      label: "活动时间",
      component: "a-date-picker",
      props: {
        format: "YYYY-MM-DD",
        valueFormat: "YYYY-MM-DD",
        placeholder: "请选择活动时间",
      },
      rules: [{ required: true, message: "请选择活动时间", trigger: "change" }],
    },
    {
      key: "position_id",
      label: "阵地名称",
      component: "a-select",
      entity: "position",
      props: {
        options: [],
        placeholder: "请选择阵地名称",
        disabled: !!position_id,
        showSearch: true,
        filterOption: (input, option) =>
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      },
      style: {
        width: "240px",
      },
      rules: [{ required: true, message: "请选择阵地名称", trigger: "change" }],
    },
    {
      key: "people_count",
      label: "参与人数",
      component: "a-input-number",
      props: {
        placeholder: "请输入参与人数",
      },
      style: {
        width: "240px",
      },
      rules: [{ required: true, message: "请输入参与人数", trigger: "blur" }],
    },
    {
      key: "img",
      label: "活动图片",
      component: "form-upload",
      props: {
        limit: 1,
      },
      rules: [{ required: true, message: "请上传活动图片", trigger: "change" }],
    },
    {
      key: "details",
      label: "活动详情",
      component: "rich-editor",
      rules: [{ required: true, message: "请输入活动详情", trigger: "blur" }],
    },
    {
      key: "sort",
      label: "排序",
      component: "a-input-number",
      props: {
        placeholder: "数字越小排位越前",
      },
      style: {
        width: "240px",
      },
    },
  ],
  // 详情接口expand字段
  expand: "?expand=admin,position",
  init: { position_id }, // 新增实体初始化字段
  // 详情渲染字段
  renderItems: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { label: "活动名称", key: "name" },
      { label: "活动时间", key: "start_time" },
      { label: "阵地名称", key: "position", slot: (entity) => <span>{entity.position?.name}</span> },
      { label: "参与人数", key: "" },
      {
        label: "活动图片",
        key: "img",
        slot: (entity) => {
          return (
            <div>{entity.img ? entity.img.split(",").map((img) => <img className="avatar" src={img} />) : "无"}</div>
          );
        },
      },
      { label: "活动详情", key: "details", rich: true },
      { label: "排序", key: "sort" },
    ];
  },
};
